import { RestrictedAccountObjectFacade } from "../restricted-account-object/restricted-account-object.facade";
import { ContactApiFacade } from "./contact.api-facade";
import { ContactStoreFacade } from "./contact.store-facade";
import { Contact } from "./contact.model";

export class ContactFacade extends RestrictedAccountObjectFacade<Contact, ContactApiFacade, ContactStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact/contact.facade.ts